// src/redux/reducers/lastWriteReducer.js
import { SET_LAST_WRITTEN_UID } from "../actions";

const initialState = { uid: null };

export default function lastWriteReducer(state = initialState, action) {
  switch (action.type) {
    case SET_LAST_WRITTEN_UID:
      return { uid: action.payload };
    default:
      return state;
  }
}
